import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [transitionStage, setTransitionStage] = useState('enter');

  useEffect(() => {
    if (children !== displayChildren) {
      setTransitionStage('exit');
    }
  }, [children, displayChildren]);

  useEffect(() => {
    if (transitionStage === 'exit') {
      const timeout = setTimeout(() => {
        setDisplayChildren(children);
        setTransitionStage('enter');
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [transitionStage, children]);

  return (
    <div 
      className={`page-transition-wrapper ${transitionStage === 'exit' ? 'page-transition-exit' : ''}`}
      key={location.pathname}
    >
      {displayChildren}
    </div>
  );
};

export default PageTransition;
